/* import '@mod-publisher/js/richcontent/all';
*/
require('./styling.css');
require('./video.es');
